/** 
 * Debounce function designed to work with Vue components.
 * Create a debounce variable in the component and use it to wrap the function you want to debounce. 
 * For example:
 * debouncedFunction = debounce(this.originalFunction, 300);
 * Then call the debounced function in your component instead of the original function, passing the arguments as needed.
 */
export function debounce<T extends (...args: any[]) => any>(fn: T, delay: number): (...args: Parameters<T>) => void {
  let timeout: ReturnType<typeof setTimeout> | null = null;

  return function (this: ThisParameterType<T>, ...args: Parameters<T>) {
    if (timeout) {
      clearTimeout(timeout);
    }

    timeout = setTimeout(() => {
      fn.apply(this, args);
    }, delay);
  };
}
